export const ROUTE_STATE_KEY = 'routes';
export const LANGUAGE_KEY = 'language';
export const REMEMBERED_ACCOUNT_KEY = 'rememberedAccount';

export const SYSTEM_CODE = 'ExWebSubmission';
export const SYSTEM_GROUP_CODE = 'ExternalWebsite';

export const SYSTEM_NAME = 'E-WebSubmission';
export const DEFAULT_LANGUAGE = 'en';
